import React from "react";
import { Edit as RaEdit, type EditProps } from "react-admin";

export const Edit = ({
    children,
    actions = false,
    sx = {},
    ...rest
}: EditProps & {
    children: React.ReactNode;
}): JSX.Element => (
    <RaEdit 
        {...rest} 
        redirect={false} 
        mutationMode="optimistic" 
        sx={{ ...sx, paddingTop: 0.5, "& .RaEdit-noActions": { margin: 0, padding: 1 } }} 
        actions={actions}
    >
        {children}
    </RaEdit>
);
